import Vue from 'vue'
import dateFormat from 'vux/src/tools/date/format.js'

import base from './api'

function string2Date(str) {
if (!str) {
return null;
}
if (str.getTime) {

return str;
}
str = str.replace("T", " ");
var arr = str.split(' ');
var date = new Date();
if (arr.length > 0) {
var arr1 = arr[0].split('-');
if (arr1.length == 3) {
var year = +arr1[0];
var month = +arr1[1] - 1;
var day = +arr1[2];
date = new Date(year, month, day);
}
}
if (arr.length > 1) {
var arr2 = arr[1].split(":");
if (arr2.length >= 2) {
date.setHours(+arr2[0]);
date.setMinutes(+arr2[1]);
}
if (arr2.length == 3) {
var arr3 = arr2[2].split(".");
if (arr3.length >= 1) {
date.setSeconds(+arr3[0]);
}
if (arr3.length == 2) {
date.setMilliseconds(+arr3[1]);
}
}
}
return date;
}

/**
* TODO:改造成微信显示时间那样?
* @param timeString
* @returns {*}
*/
function getFirendlyTimeString(timeString) {
if (!timeString)
return "";

var nowTime = new Date().getTime();
var date = timeString;
if (typeof timeString == "string") {
date = string2Date(timeString);
}
var time = date.getTime();
let str = "前";
let diffvalue = nowTime - time;
if (0 > nowTime - time) {
str = "后";
}
var diff = Math.abs(nowTime - time);
var m = 60 * 1000;
var h = m * 60;
if (diff < m) {
return "刚刚";
}
if (diff > m && diff < h) {
return Math.floor(diff / m) + "分钟" + str;
}
if (diff >= h && diff < 5 * h) {
return Math.floor(diff / h) + "小时" + str;
}
var hour = date.getHours();
if (hour < 10) {
hour = "0" + hour;
}
var minute = date.getMinutes();
if (minute < 10) {
minute = "0" + minute;
}
var hm = hour + ":" + minute;
var nowDate = new Date(nowTime);
var i = nowDate.getDate();
var j = date.getDate();
if (diff >= 5 * h && diff < 72 * h) {
if (i - j == 0) {
return "今天" + hm;
}
if (i - j == 1) {
return "昨天" + hm;
}
if (i - j == 2) {
return "前天" + hm;
}
if (i - j == -1) {
return "明天" + hm;
}
if (i - j == -2) {
return "后天" + hm;
}
}
if (diff < 60 * 24 * h) {
return Math.floor(diff / 24 / h) + '天' + str;
}
var year = date.getFullYear();
var month = date.getMonth() + 1;
return year + "年" + month + "月";

}
function getFirendlyDateString(timeString) {
if (!timeString)
return "";
var nowDate = new Date();
nowDate.setHours(0);
nowDate.setMinutes(0);
nowDate.setSeconds(0);
nowDate.setMilliseconds(0);
var date = timeString;
if (typeof timeString == "string") {
date = string2Date(timeString);
}
date.setHours(0);
date.setMinutes(0);
date.setSeconds(0);
date.setMilliseconds(0);

var nowTime = nowDate.getTime();
var time = date.getTime();
var diff = Math.abs(nowTime - time);

var i = nowDate.getDate();
var j = date.getDate();
var m = 60 * 1000;
var h = m * 60;
if (diff < 72 * h) {
if (i - j == 0) {
return "今天";
}
if (i - j == 1) {
return "昨天";
}
if (i - j == 2) {
return "前天";
}
}
var year = date.getFullYear();
var month = date.getMonth() + 1;
return year + "-" + month + "-" + j;
}

const filters = {
dateFormat(value, format = 'YYYY-MM-DD HH:mm:ss') {
var date = string2Date(value);
return dateFormat(date, format)
},
niceTime(value){
return getFirendlyTimeString(value);
},
fsUrl(value, thumbnail){
/*if(value && value.startsWith("n:")){
thumbnail = thumbnail || 'm';
var replacement = 'http://fs-$1.360ease.com/$2$3';
if(thumbnail !== 'o'){
replacement = 'http://fs-$1.360ease.com/$2_' + thumbnail + '$3';
}
return value.replace(/n:([^\/]+)\/([^\.]+)((\.?).*)/, replacement);
}
return value;*/
return base.wx.fsUrl(value, thumbnail);
},
nameImg(val) {
val += '';
if (val.length >= 2) {
val = val.substring(0, 1);
}
return val;
},
comma: function(item){
item = (item || "").split(",");
item = item[0] ? (item[0]  + (item[1]?(" | " + item[1] + (item[2]?(" | " + item[2] + (item[3]?"...":"")):"")):"")):"";
return item;
},
tenMillion: function(item){
return (item / 10000).toFixed(2);
},
formatTime(timeStr) {
if(timeStr && timeStr.length>9){
return timeStr.substr(0, 10);
}
return timeStr;
}
};

for (let p in filters) {
if (!filters.hasOwnProperty(p)) continue;

Vue.filter(p, filters[p])
}



// WEBPACK FOOTER //
// ./src/filters.js